import * as React from 'react';
import * as reg from "./style.module.scss";
export const Reg = ({ widget, free }) => {
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.container}>
          <h2>Осваивать новую профессию всегда проще, понимая термины</h2>
          <div className={reg.formWrap}>
            <div className={reg.form}>
              <div className={reg.priceWrap}>
                <h3>Стоимость:</h3>
                <p>
                  <span className={reg.oldPrice}>10&nbsp;000&nbsp;₽</span>
                  { !free && <span className={reg.price}>7&nbsp;900&nbsp;₽</span> }
                </p>
              </div>
              <div className={reg.widget} id={'widget'}>
                { widget }
              </div>
            </div>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/registration.png" alt=""/>
          </div>
          <p className={reg.fit}>Подходит для людей с начальным уровнем английского языка</p>
        </div>
      </div>
    </section>
  );
};
